import { useEffect } from 'react';

const useOutsideClick = (ref, callback, isClassCall) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      return callback(e.target);
    }
  };

  if (!isClassCall) {
    useEffect(() => {
      document.addEventListener('click', handleClick);

      return () => {
        document.removeEventListener('click', handleClick);
      };
    });
  } else {
    document.addEventListener('click', handleClick);
  }
};

export default useOutsideClick;
